import { useState } from "react";
import { useAsyncModal } from "hooks";
import { Modal } from "components/utils";
import { Button } from "components/common";
import styles from "./ToolbarDateAsyncModal.module.css";
import { DatePicker } from "components/utils/datePicker";
import { dateFns } from "utilities";

export const SingleToolbarDateAsyncModal = ({ id }: { id: Symbol }) => {
  const asyncModal = useAsyncModal();
  const isOpen = asyncModal.opened === id;
  const [pickedDate, setPickedDate] = useState("");
  return (
    <Modal isOpen={isOpen} close={asyncModal.close} size={{ all: { width: "300px" } }}>
      <div>
        <div>
          <h5 className="pb-3">Wskaż datę</h5>
        </div>
        <div className="position-relative">
          <DatePicker
            className={styles.date}
            value={pickedDate}
            onChange={date => {
              if (!date) {
                setPickedDate("");
              } else {
                setPickedDate(dateFns.format(new Date(date), "yyyy-MM-dd"));
              }
            }}
            overwrites={{ popup: { className: styles.datePickerPopup } }}
          />
        </div>
        <div className="d-flex align-items-center justify-content-end pt-4">
          <Button
            kind="primary"
            onClick={() => {
              asyncModal.resolve(pickedDate);
            }}
          >
            Szukaj
          </Button>
        </div>
      </div>
    </Modal>
  );
};
